import {trim} from "es-toolkit";
import type {ISbStoryData} from "storyblok-js-client";
import type {AsyncData} from "nuxt/app";
import {type ReffedParameters, unrefParameters} from "../helpers/storyblok";
import {
	useAsyncDataWithPausing,
	type AsyncDataOptionsWithPausing,
} from "./use-async-data-with-pausing";

import {isRef} from "vue";
import {useRuntimeConfig} from "nuxt/app";
import {useStoryblokApi} from "@storyblok/vue";

// NOTE: Also see `useStoryblokStories` and `useStoryblokStoriesList`

export function useStoryblokStory(
	path: string,
	parameters: ReffedParameters = {},
	asyncOptions: AsyncDataOptionsWithPausing<ISbStoryData | null> = {},
): AsyncData<ISbStoryData | null, unknown> {
	const api = useStoryblokApi();
	const watchValues = Object.values(parameters).filter((value) => isRef(value));

	return useAsyncDataWithPausing<ISbStoryData | null, unknown>(
		`${path}:${JSON.stringify(unrefParameters(parameters))}`,
		async () => {
			const storyRes = await api.getStory(trim(path, "/"), {
				resolve_links: "url",
				...unrefParameters(parameters),
				version:
					useRuntimeConfig().public.storyblokVersion === "published"
						? "published"
						: "draft",
			});

			return storyRes.data.story;
		},
		{
			watch: watchValues,
			...asyncOptions,
		},
	);
}
